<template>
  <!-- 绑定邮箱/手机号/弹层 -->
  <div class="bindTips" @click="cancelForm()">
    <div class="tipsContent pa bg_fff" @click.stop>
      <div class="tipsTitle f_18 color_40 font_w_b">常用手机号</div>

      <div class="form">
        <dl class="formItem flex" :class="[bindTipsError.phone?'errorTips':'']">
          <dt class="f_14 color_60"><span>手机号码</span>：</dt>
          <dd class="flex1">
            <div class="phoneBox flex-c">
              <div class="phoneType text_center f_14 color_60">

                <el-select v-model="choose" placeholder="+86" @change="change" >
                     <el-option
                      v-for="item in choos"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value">
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px; margin-left:59px">{{ item.value }}</span>
                     </el-option>
                    </el-select>
              </div>
              <el-input class="restInput noBorder f_14 color_40 flex1" v-model="bindTipsData.phone" placeholder="请输入你的手机号" @focus="inputFocus('phone')" :maxlength="20" ></el-input>
            </div>
            <!-- 错误提示 -->
            <div class="errorTipsDesc f_14" v-if="bindTipsError.phone">
              <span class="iconfont iconinfo"></span>
              <span class="tipsName">{{bindTipsError.phone}}</span>
            </div>
          </dd>
        </dl>
        <dl class="formItem flex" :class="[bindTipsError.code?'errorTips':'']" v-show="select == '中国大陆'" >
          <dt class="f_14 color_60"><span>验证码</span>：</dt>
          <dd class="flex1">
            <div class="codeBox flex-c">
              <el-input class="restInput noBorder f_14 color_40 flex1" v-model="bindTipsData.phone_token" placeholder="请输入验证码" @focus="inputFocus('code')" :maxlength="6" ></el-input>
              <div class="time cursor_p text_center f_14">
                <span class="color_current" @click="checkCode('phone')" v-if="bindTipsOptions.time === 60">发送验证码</span>
                <span class="color_90" v-else >{{bindTipsOptions.time}}s</span>
              </div>
            </div>
            <!-- 错误提示 -->
            <div class="errorTipsDesc f_14" v-if="bindTipsError.code">
              <span class="iconfont iconinfo"></span>
              <span class="tipsName">{{bindTipsError.code}}</span>
            </div>
          </dd>
        </dl>
      </div>

      <div class="formButtons clearfix">
        <div class="fr confirm text_center bg_red color_fff f_14 cursor_p" @click="updateInfo()">确定</div>
        <div class="fr cancel text_center color_60 f_14 cursor_p" @click="cancelForm()">取消</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { routerTo, get_tUser } from '@/assets/js/util';
  import { uuid } from 'vue-uuid';
  import api from '@/api';
  import { mapGetters, mapActions, mapState } from 'vuex'
  export default {
    data () {
      return {
        select:'中国大陆',
        choose:'',
        choos: [
          {name:'中国大陆',value:'+86'},
          {name:'中国香港',value:'852'},
          {name:'中国台湾',value:'886'},
          {name:'美国',value:'1'},
          {name:'英国',value:'44'},
          {name:'日本',value:'81'},
          {name:'澳大利亚',value:'61'},
          {name:'法国',value:'33'},
          {name:'加拿大',value:'1 '},
          {name:'韩国',value:'82'},
          {name:'俄罗斯',value:'7'},
          {name:'德国',value:'49'},
          {name:'瑞士',value:'41'},
          {name:'新加坡',value:'65'},
          {name:'其他',value:'其他'},
          ],
        timeName:null,
        requestState:false,//接口请求的状态
        bindTipsOptions:{
          time:60, //倒计时
          getCodeState:false, //是否正在获取验证码
        },
        bindTipsError:{ //弹窗错误提示
          phone:'',
          phone_token:'',
        },
        bindTipsData:{ //绑定手机号参数
          phone:'',
          phone_token:'',
        },
      }
    },
    created(){
      this.choose = this.choos[0].value
      //console.log(this.choose,this.select)
      //console.log(this.choos,this.country,this.choose,this.select,this.personInfo)
    },
    computed: {
      ...mapState('me', [ 'personInfo' ]),
       country() {

        let countrys = this.choose;
        let options = this.choos;
       // console.log(options)
        let item = options.filter(item => item.name === countrys) || []
        // console.log(item)
        return item.length ? item[0].value : ''

      },
    },
    methods:{
     async change(item1) {
       // console.log(item1)
        this.select = this.choos.filter(item => {
        return item.value == item1
      })[0].name
      //console.log(this.select)
      //获得用户信息 试存手机号码代码
       /* let {c_t} = get_tUser()
        let resget = await api.account.getUsersBasicInfo(c_t,'','GET')
        console.log(resget)
         if(resget.code === 1000) {
          let bindParams = {
          name: resget.data.name,
          gender: resget.data.gender,
          contact:this.bindTipsData.phone,
          birthday:resget.data.birthday
          }
          let resover = await api.account.updateUsersBasicInfo(c_t,bindParams)
          console.log(resover)
        }  */
      },
      optionChange(){},
      cancelForm(phone=''){
        clearInterval(this.timeName);
        this.$emit('cancelBindForm',phone)
      },
      //【bindTips】获取验证码 手机号/邮箱
      checkCode(){
        let { time, getCodeState, } = this.bindTipsOptions;
        let { phone, phone_token, } = this.bindTipsData; //绑定手机号参数
        if(getCodeState){
          return false;
        }
        let formState = true;
        if(!phone){
          this.bindTipsError.phone = '请输入手机号';
          formState = false;
        }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
          this.bindTipsError.phone = '请输入正确的手机号';
          formState = false;
        }
        if(!formState){
          return false;
        }

        this.getCode();
      },
      //【手机】获取短信验证码-接口
      async getCode(){
        let { time, getCodeState, } = this.bindTipsOptions;
        let {c_t} = get_tUser()
        //console.log(c_t)
        let res = await api.account.getVeriCode(c_t,{phone:this.bindTipsData.phone})
        //console.log(res)

        if(getCodeState){
          return false;
        }
        this.bindTipsData.getCodeState = true;
          if(res.code === 1000){
            this.$message({
              message: '获取验证码成功',
              type: 'success'
            });
            this.bindTipsOptions.time = 59;
            this.codeTime();
          }else{
            this.bindTipsData.getCodeState = false;
            this.$message({
              message: res.message,
              type: 'error'
            });
          }


      },
      // 绑定用户信息前的验证 手机号/邮箱
      async updateInfo(){
        let {c_t} = get_tUser()
        let { time, getCodeState, } = this.bindTipsOptions;
        let { phone, phone_token, } = this.bindTipsData; //绑定手机号参数
        let formState = true;
        if(this.select !='中国大陆') {
           this.$emit('success',true,phone)
           //this.cancelForm(phone);
        } else{
          if(!phone){
            this.bindTipsError.phone = '请输入手机号';
            formState = false;
          }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
            this.bindTipsError.phone = '请输入正确的手机号';
            formState = false;
          }
          if(!phone_token || phone_token.length<4){
            this.bindTipsError.code = '请输入正确的验证码';
            formState = false;
          }
          if(!formState){
            return false;
          }
        }
        let params = {
          phone,
          code: phone_token
        }
        //绑定手机号
        this.bindingPhone(c_t,params);
      },
      //绑定手机号
      async bindingPhone(token,params){
        // let resget = await api.account.getUsersBasicInfo(token,{})
        // let bindParams = {
        //   name: resget.data.name,
        //   gender: resget.data.gender,
        //   contact: `${this.choose}-${params.phone}`,
        //   birthday:resget.data.birthday
        // }
        if (this.select !== '中国大陆') {
          this.$emit('success',true, `${this.choose}-${params.phone}`)
          this.$message({
            message: '手机号保存成功',
            type: 'success'
          });
          this.cancelForm(`${this.choose}-${params.phone}`)
        //   if(params.phone) {
        //     let resover = await api.account.updateUsersBasicInfo(token,bindParams)
        //     //console.log(resover)
        //     if (resover.code === 1000) {
        //       this.$emit('success',true,params.phone)
        //       this.$message({
        //         message: '手机号保存成功',
        //         type: 'success'
        //       });
        //     }
        //     this.cancelForm(params.phone)
        //  }else {
        //     this.$message({
        //       message: '请输入手机号',
        //       type: 'error'
        //     });
        //   }
        }else {
          let res = await api.account.verifyCode(token,params)
          //console.log(res)
          if(res.code === 1000){
            this.$emit('success',true,params.phone)
            // let resover = await api.account.updateUsersBasicInfo(token,bindParams)
            //console.log(resover)
            this.$message({
              message: '手机号验证成功',
              type: 'success'
            });
            this.cancelForm(params.phone);
          }else{
            this.bindTipsData.getCodeState = false;
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        }


      },
      //【邮箱】倒计时
      codeTime(){
        this.timeName = setInterval(() => {
          if(this.bindTipsOptions.time == 1){
            clearInterval(this.timeName);
            this.bindTipsOptions.time = 60;
            this.bindTipsOptions.getCodeState = false;
            return false;
          }
          this.bindTipsOptions.time = this.bindTipsOptions.time-1;

        }, 1000);
      },
      //【bindTips】取消错误提示
      inputFocus(type){
        this.bindTipsError[type] = '';
      },
    }
  }
</script>
<style lang="scss">
// <style lang="scss" scoped>
  // 公共初始化样式
  @import '~/assets/css/public';
  // 绑定邮箱弹层
  .bindTips{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: .4);
    z-index: 9;
    //错误提示样式
    .errorTipsDesc{
      color: #FD5F39;
      line-height: 24px;
      .iconfont{
        position: relative;
        top: 1px;
      }
      // .tipsName{
      //   margin-left: 8px;
      // }
    }
    .tipsContent{
      width: 446px;
      padding: 32px 32px;
      box-sizing: border-box;
      border-radius:4px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .tipsTitle{
        line-height: 18px;
      }
      .form{
        padding: 40px 0 1px;
        .formItem{
          margin-bottom: 32px;
          &.errorTips{
            margin-bottom: 12px !important;
          }
          dt{
            width: 70px;
            line-height: 40px;
          }
          dd{
            padding-left: 12px;
          }
        }
      }
      .formButtons{
        .confirm{
          width: 84px;
          height: 36px;
          line-height: 36px;
          margin-left: 16px;
        }
        .cancel{
          width: 82px;
          height: 34px;
          line-height: 34px;
          border: 1px solid #D9D9D9;

        }
      }
      .codeBox,.phoneBox{
        height: 40px;
        border-radius:2px;
        border:1px solid rgba(236,236,236,1);
        .time{
          line-height: 22px;
          height: 22px;
          width: 102px;
          border-left: 1px solid #DCDFE6;
        }
        .phoneType {
          width: 75px;
          .el-select {
             .el-input__inner {
                border: 0;
               // height: 40px;
             }
          }
        }

  /*       .phoneType{
          line-height: 22px;
          //margin-left: 32px;
          height: 22px;
          width: 74px;
          border-right: 1px solid #DCDFE6;

        } */

         /*  .el-select {
            height: 40px;
            width: 74px;
            //margin-top: -19px;
            margin-left: 32px;
            .el-input{
              height: 40px;
              width: 74px;
             .el-input__inner {
                border: 0;
                height: 40px;
             }
            }
          }  */
      }
    }
  }
</style>
